<template>
	<div class="statistica__per-month">
		<div class="statistica__item">
            <div class="statistica__per-month-title">
                <div class="statistica__per-month-title_text">{{monthes[month]}}
                    <!--<i class="icon-calendar" @click="showPopup"></i>-->
                </div>
                <div class="statistica__per-month-title_data">
                    <span>
                        <watch :data="profit"
						   :units="'$'"
						>
                        </watch>
                    </span>
                    <span>
                        <watch :data="profitPercent"
						   :units="'$'"
						>
                        </watch>
                    </span>
                </div>
            </div>
            <div class="statistica__per-month-row">
                <!--<table class="statistica__per-month-row">
                    <tr v-for = "(day, number) in weekSum" :key="number + 'day'" class="statistica__per-month-item">
                        <td class="statistica__per-month-item-title-date">{{day[0].dateFormat}}/{{day[day.length - 2].dateFormat}}</td>
                        <td class="statistica__per-month-item-data-sum"
                                :class = "((day[day.length - 1].profitAbs < 0) ? 'color-red' : 'color-green')">$ {{$moneyf(day[day.length - 1].profitAbs,0)}}</td>
                        <td class="statistica__per-month-item-data-pips"
                                :class = "((day[day.length - 1].profitRel < 0) ? 'color-red' : 'color-green')">{{(day[day.length - 1].profitRel).toFixed(2)}}%</td>
                        <td class="statistica__per-month-item-data-probability">{{day[day.length - 1].equityOnEod}}</td>
                        <td class="statistica__per-month-item-data-maxdd">{{(day[day.length - 1].maxDd).toFixed(2)}}</td>
                    </tr>
                </table>-->
                <chart :points = "points" :fixedWidth = "320"
                :fixedHeight = "110" :smooth="false" :data="this.profit"></chart>
            </div>
        </div>
        <transition enter-active-class="animated fadeIn"
				leave-active-class="animated fadeOut">
            <div v-show="popup" class="statistica-popup">
                <div class="statistica-changeDate">
                    <div class="statistica-changeDate-item">
                        <div class="statistica-changeDate-item-options">
                            <span>год</span>
                            <select v-model="yearPeriod" @change="setMonth">
                                <option v-for="(item,index) in uniqueYear" :key="index">{{item}}</option>u
                            </select>
                        </div>
                        <div class="statistica-changeDate-item-options">
                            <span>месяц</span>
                            <select v-model="monthPeriod">
                                <option v-for="(item,index) in monthInYear" :key="index + 'month'">{{item}}</option>u
                            </select>
                        </div>
                    </div>
                    <input type="button" value="OK" @click="setDate">
                </div>
            </div>
        </transition>
        <transition enter-active-class="animated fadeIn"
				leave-active-class="animated fadeOut">
            <div v-show="popup" class="statistica-overlay"></div>
        </transition>
	</div>
</template>
<script>
import { mapGetters } from "vuex";
import Vue from 'vue';
import Chart from '../../../ui-components/ui-mini-linechart';
import Watcher from '../../../ui-components/ui-data-watcher';

export default {
    components: {
        'chart':Chart,
        'watch':Watcher
    },
	data() {
		return {
            weekSum:null,
            numberWeek:0,
            monthes:['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'],
            month:null,
            year:null,
            points:null,
            profit:null,
            profitPercent:0,
            popup:false,
            yearPeriod:null,
            uniqueYear:null,
            monthInYear:null,
            monthPeriod:null,
            datePeriod:null,
		};
	},
	computed: {
		...mapGetters({
              getMonthStat: 'accountstat/getMonthStat',
              getPeriod: 'accountstat/getPeriod',
              getMonthsInYear: 'accountstat/getMonthsInYear'
        }),
        getMonthAndYear() {
            if(this.weekSum !== null) {
                let nowDate = new Date(this.weekSum[0].date)
            }
        }
	},
	methods: {
		updateData() {
           let stat = this.getMonthStat('',this.datePeriod);
           if(stat.week.length === 0)
                return;
            this.weekSum = stat.week;
            this.uniqueYear = this.getPeriod('');
            this.points = this.getPoints(stat);
            let equityOfBeginMonth = stat.week[0][0].equityOnBod;
            let lastWeek = stat.week[stat.week.length - 1];
            let equityOfLastDay = lastWeek[lastWeek.length - 2].equityOnEod;
            this.profit = equityOfLastDay - equityOfBeginMonth;
            this.profitPercent = 100/(equityOfLastDay/this.profit);
            let nowDate = new Date(this.weekSum[0][0].date);
            this.month = nowDate.getMonth();
            this.year = nowDate.getFullYear();
        },
        setMonth() {
            this.monthInYear = getMonthName(this.getMonthsInYear('', this.yearPeriod));
        },
        getPoints(stats) {
            let endsOfWeeks = [];
            for(let i = 0; i < stats.week.length; i++)
            {
                for(let j = 0; j < stats.week[i].length - 1; j++) {
                    if(stats.week[i][j].date === stats.week[i][stats.week[i].length - 2].date)
                        endsOfWeeks.push(stats.week[i][j].equityOnEod);
                }
            }
            endsOfWeeks.unshift(stats.week[0][0].equityOnBod);
            return endsOfWeeks;
        },
        showPopup() {
            this.popup = true;
        },
        setDate() {
            this.datePeriod = new Date(this.yearPeriod, this.monthes.indexOf(this.monthPeriod));
            this.updateData();
            //this.dateForTitle = this.datePeriod;
            this.popup = false;
        },
	},
	created() {
        subscribeOnUpdate(this.$store, '', isFirstObtained => {
            this.updateData();
        });
        this.updateData();
    } // created }
};

function subscribeOnUpdate(store, symbol, handler) {
    store.dispatch("accountstat/subscribeOnUpdate", {
        symbol: "",
        callback: {
            id: "weeks-widget-mobile",
            handler: handler
        }
    });
}
function getMonthName(arrayMonth) {
    let month = ['Январь', 'Февраль','Март','Апрель', 'Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
    let monthName = [];
    for(let i = 0; i < arrayMonth.length; i++) {
        monthName.push(month[arrayMonth[i]]);
    }
    return monthName;
}
</script>

<style lang="less" scoped>
.statistica {
    &-popup {
        position: fixed;
        top:40%;
        left:8px;
        right: 8px;
        max-width: 100%;
        height: 150px;
        background: #3d536b;
        border-radius: 8px;
        z-index: 10;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    &-overlay {
        position: fixed;
        display: block;
        left: 0;
        margin-right: 8px;
        top:0;
        width: 100%;
        min-height: 100vh;
        background:rgba(0,0,0,0.7);
        z-index: 1;
    }
    &-changeDate {
        display: flex;
        flex-direction: column;
        align-items: center;
        &-item {
            display: flex;
            &-options {
                display: flex;
                flex-direction: column;
                margin-right: 16px;
                &:last-child {
                    margin-right: 0px;
                }

            }
        }
        select {
            font-family: Montserrat;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            font-size: 120%;
            background: #fff;
            padding: 4px;
            border-radius: 4px;
        }
        span {
            font-family: Montserrat;
            font-size: 20px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: normal;
            letter-spacing: 0.4px;
            color: #fff;
            margin-right: 16px;
        }
    }
}
input[type="button"]
    {
        height: 40px;
        border-radius: 4px;
        width: 100px;
        background-color: #0fd7b7;
        border: none;
        margin-top: 16px;
        color:#374b62;
        cursor: pointer;
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;

        &:disabled
        {
            background-color: #718da8;

            &:hover
            {
              background-color: #718da8;
            }
        }

        &:hover
        {
            background-color: @colors[green];
        }
}
.statistica__item {
    margin-bottom: 8px;
    display: block;
    background: #3d536b;
    border-radius: 4px;
    overflow: hidden;
}
.statistica__per-month {
    width: 100%;
    &-title {
        font-family: Montserrat;
        font-weight: normal;
        font-size: 18px;
        font-style: normal;
        font-stretch: normal;
        //text-transform: uppercase;
        color: #ffffff;
        padding-left: 16px;
        background-color: #3d536b;
        border-bottom: 1px solid #374b62;
        margin-bottom: 0px;
        padding: 8px 8px;
        height: 45px;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        &_text {
            display: flex;
            align-items: center;
        }
        &_data {
            display: flex;
            align-items: center;
        }
        i {
            margin-left: 8px;
            margin-top: 4px;
        }
        span {
            font-family: Arimo;
            //font-weight: 600;
            margin-right: 8px;
            &:first-child {
                margin-left: 8px;
            }
            &:last-child {
                margin-right: 0px;
            }
        }
    }
    &-row {
        display: flex;
        justify-content: center;
        padding-top: 8px;
    }

    &-item {
        border-top: solid 1px #374b62;
        padding: 0 8px 0 12px;
        height: 29px;
        &-title{
            padding: 8px 0;
            border-bottom: 1px solid #374b62;
            display: flex;
            justify-content: space-between;

            &-day {
                font-family: Arimo;
                font-size: 12px;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                padding-left: 12px;
                color: #ffffff;
            }

            &-date {
                font-family: Arimo;
                font-size: 12px;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                padding-left: 16px;
                color: #aabed2
            }
        }

        &-data {
            padding: 12px 12px 8px 12px;

            &-sum {
                font-family: Arimo;
                font-size: 13px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.25;
                letter-spacing: 0.4px;
                text-align: left;
            }

            &-pips {
                font-family: Arimo;
                font-size: 13px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.54;
                letter-spacing: 0.4px;
            }

            &-probability {
                font-family: Arimo;
                font-size: 12px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                text-transform: uppercase;
                color: @colors[green];
                margin-top: 8px;
            }

            &-maxdd {
                font-family: Arimo;
                font-size: 12px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 2;
                letter-spacing: 0.4px;
                color: #ff9292;
                }
        }

        &-chart {
            width: 100%;
            display: block;
            //flex-grow: 1;
            min-height: 200px;
        }
    }
}
</style>
